export default __webpack_public_path__ + "static/media/circle-add.8c2e9af3.svg";